import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FaUser, FaSortDown } from 'react-icons/fa'
import { FiLogOut } from 'react-icons/fi'
import { getRoleName, getEntityName } from 'utils/Auth'

const Topbar = (props) => {
    const [isUserMenuShown, setIsUserMenuShown] = useState(false)
    const [museumName, setMuseumName] = useState("")

    useEffect(() => {
        const initialize = async () => {
            const entityName = await getEntityName(props.currentUser)
            setMuseumName(entityName)
        }
        if (props.currentUser) {
            initialize()
        }
    }, [props.currentUser])

    const toggleUserMenu = () => {
        setIsUserMenuShown(!isUserMenuShown)
    }

    return (
        <div id="topNav">
            {props.currentUser &&
                <>
                    <div className="title mt-1">
                        <Link to={`${props.currentUser.entityId ? '/museum/' + props.currentUser.entityId + '/dashboard/' : '/museums'}`}>RETOLD <span className="text-yellow">PORTAL</span> <span className="subtitle">{museumName && `- ${museumName}`}</span></Link>
                    </div>
                    <div className="user" onClick={toggleUserMenu}>
                        <div className="user-icon"><FaUser /></div>
                        <div className="user-info">
                            <div className="user-name">{props.currentUser.name}</div>
                            <div className="user-role">{getRoleName(props.currentUser)}</div>
                        </div>
                        <div className="dropdown-icon"><FaSortDown /></div>
                    </div>
                    <div className={`userMenu ${isUserMenuShown ? '' : 'hidden'}`}>
                        <div><Link to={`${props.currentUser.entityId ? '/museum/' + props.currentUser.entityId + '/users/' + props.currentUser.id + '/edit' : '/users/' + props.currentUser.id}`}><div><FaUser /></div><div>User Profile</div></Link></div>
                        <div><Link to="/logout"><div><FiLogOut /></div><div>Logout</div></Link></div>
                    </div>
                </>
            }
            {props.loggingOut &&
                <>Logging out...</>
            }
        </div>
    )
}

export default Topbar